module.exports = __webpack_public_path__ + "img/clement1.37440a21.png";